<template>
    <loading name='load user events'>
        <div class="container body fix-footer">
            <div class="row justify-content-center">
                <div class="col-md-8 mt-5 mb-3">
                    <div class="card">
                        <div class="card-header">
                            <h3>{{$t('pages.AvailableEvents')}}</h3>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger" v-if="error">{{$t(error)}}</div>
                            <form @submit="submit" v-if="events.length">
                                <formly-form :form="form" :model="model" :fields="fields" ref="choose"/>
                                <div class="text-right">
                                    <button class="btn btn-primary">{{ $t('button.Next') }}</button>
                                </div>
                            </form>
                            <div v-else class="text-center">
                                <h1 class="far fa-smile green-check"></h1>
                                <p>{{$t('userEvent.alreadySubscribed')}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </loading>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import {ROUTER_NAMES} from '../../constants';
  import find from 'lodash/find';


  export default {
    name: 'AvailableEvents',
    data() {
      const availableEventsOptions = [];

      return {
        disabled: false,
        error: '',
        form: {
          event: null,
        },
        model: {
          event: '',
        },
        fields: [
          {
            key: 'event',
            type: 'multi-select',
            options: availableEventsOptions,
            templateOptions: {
              label: this.$t('fields.Event'),
              multiple: false,
              closeOnSelect: true
            },
            required: true
          },
        ]
      };
    },
    created() {
      this.$wait.start('load user events');
      this.userEvents().then(() => {
        this.$wait.end('load user events');
        const availableEventsOptions = this.events.map((event) => {
          return {
            label: event.name,
            value: event.id
          };
        });


        if (availableEventsOptions.length === 1) {
          this.$router.push({
            name: ROUTER_NAMES.USER_EVENT_REGISTER,
            params: {
              eventId: availableEventsOptions[0].value
            }
          });
        }

        this.fields[0].options = availableEventsOptions;
      });
    },
    computed: {
      ...mapGetters(['availableEvents', 'userEventRegistrations']),
      events() {
        return this.availableEvents ? this.availableEvents.filter((event) => {
          return !find(this.userEventRegistrations, {event_id: event.id});
        }) : this.availableEvents;
      }
    },
    methods: {
      ...mapActions(['userEvents']),
      submit(e) {
        e.preventDefault();
        this.error = null;
        this.$refs.choose.validate()
          .then(() => {
            if (!this.form.$valid) return;
            this.disabled = true;

            this.$router.push({
              name: ROUTER_NAMES.USER_EVENT_REGISTER,
              params: {
                eventId: this.model.event.value
              }
            });
          })
          .catch(() => {
            this.disabled = false;
          });
      },
    }
  };
</script>

<style scoped>

</style>
